export const ProductTemplating = {
    productMarker: (marker) => {
        return marker ? `<span class="tile__badge ata__badge" 
                    style="${marker?.textColor ? 'color:' + marker?.textColor + ';' : ''}${marker?.backgroundColor ? 'background-color:'
                + marker?.backgroundColor + ';' : ''}">
                ${marker?.label}
            </span>` : '';
    },

    colorSwatchesTemplate: (item) => {
        let colorCounter = 0;
        let swatchesList = '';
        item?.colorSwatchesVariants.forEach((colorSwatch, index) => {
            if (index < 5) {
                swatchesList +=
                        `<img class="js-tile__swatch tile__swatch ${colorSwatch.colorSwatchName === 'white' ? 'tile__swatch--border' : ''}"
                    src="${colorSwatch.colorSwatchUrl}"
                    alt="${colorSwatch.colorSwatchName}"
                    data-color-code="${colorSwatch.codeVariant}">`
            } else {
                colorCounter++;
            }
        });

        swatchesList += colorCounter > 0 ? `<span>+${colorCounter}</span>` : '';

        return `<div class="tile__swatches">
                ${swatchesList}
            </div>`
    },

    listGalleryImages(item) {
        let galleryImages = '';
        if (item?.productCardImages?.length) {
            item?.productCardImages.map(itemImage => {
                galleryImages += `<img class="tile__image intrinsic__item cld-responsive"
                    data-src="${itemImage.url}" lazydynamic animated
                    src="${this.fakeBg}"
                    title="${itemImage.altText}"
                    alt="${itemImage.altText ? itemImage.altText : itemImage.name}">`
            });
        }
        return galleryImages;
    },
    featuresList(features) {
        let featureList = '';
        let featuresCounter = 0;
        features.forEach((feature, index) => {
            if (index < 3) {
                featureList += this.getFeatureTag(feature)
            } else {
                featuresCounter++;
            }
        });

        if (featuresCounter > 0) {
            featureList += `<span class="tile__features--number">+${featuresCounter}</span>`;
        }

        return featureList;
    },

    getDiscountPriceTag(oldPrice) {
        return `<s class="tile__price--strike">${oldPrice}</s>`
    },

    getFeaturesTag(features) {
        return `<div class="tile__features">
        ${this.featuresList(features)}
    </div>`
    },

    getFeatureTag(feature) {
        return `<img class="js-tech-trigger tile__feature" src="${feature.icon.url}" alt="${feature.icon.altText}" title="${feature.title}" data-tech-code="${feature.code}">`
    },

    productTemplate(item, index, id) {
        let textStyle = '', backgroundStyle = '', itemClassName = 'carousel__item--name', priceClassName = 'carousel__item--price';
        return `<div class="product-carousel__slide">
                    <article id="pc-${item.code}" class="tile js-product-tile" 
                    data-slides="${item.productCardImages.length}">
                        <a href="${window['ACC']['config']['encodedContextPath']}${item.url}" title="${item.name}" 
                            class="js-tile-track" 
                            data-tracking-json="${item.trackingJson}"
                            data-position="${index}" 
                            data-listing-type="${id || 'carousel'}" data-listing-name="${id || 'carousel'}" 
                            data-event-callback="${window['ACC']['config']['encodedContextPath']}${item.url}" 
                            data-variant="${item.baseProduct}">
                            
                            <div class="tile-gallery intrinsic intrinsic--3x4">
                                <div class="tile-slider"
                                     data-parallax='{"max":-6, "min":0, "res":"any", "unit":"%", "startPoint":1, "hardness": 0.05}'>
                                    ${this.listGalleryImages(item)}
                                </div>
                                <div class="tile__controls">
                                    <button type="button" class="btn-reset tile__arrow tile__arrow-left" aria-label="${this.ariaLabelPrev}">
                                        <svg class="icon cms-storyslider__icon">
                                            <use xlink:href="#ico-arrow-left"></use>
                                        </svg>
                                    </button>
                                    <button type="button" class="btn-reset tile__arrow tile__arrow-right" aria-label="${this.ariaLabelNext}">
                                        <svg class="icon cms-storyslider__icon">
                                            <use xlink:href="#ico-arrow-right"></use>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div class="tile__body">
                                ${this.productMarker(item?.marker)}
                                <h3 class="tile__name text-truncate" data-context="default" ${textStyle}>
                                    <span class="tile__product-name">${item.name}</span>
                                    <span class="tile__price ${priceClassName}">
                                        ${item.oldPrice
                ? `<span class="tile__price--discounted" ${textStyle}>${item.price.formattedValue}</span>`
                : `<span class="tile__price--real" ${textStyle}>${item.price.formattedValue}</span>`}
                                        ${item.oldPrice ? this.getDiscountPriceTag(item.oldPrice.formattedValue) : ''}
                                    </span>
                                </h3>
                                <div class="tile__headline text-truncate">${item.headline}</div>    
                                ${this.colorSwatchesTemplate(item)}                           
                                ${item.features ? this.getFeaturesTag(item.features) : ''}
                            </div>
                        </a> 
                    </article>
               </div>`
    },
}
